import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useTheme } from '../context/ThemeContext';

const { FiCompass, FiMenu, FiX, FiMoon, FiSun } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { theme, toggleTheme } = useTheme();

  return (
    <motion.header 
      className="header"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        <div className="logo">
          <SafeIcon icon={FiCompass} className="logo-icon" />
          <span className="logo-text">MindFlow</span>
        </div>
        
        <div className="flex items-center gap-4">
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <a href="#problem" className="nav-link" onClick={() => setIsMenuOpen(false)}>The Problem</a>
            <a href="#solution" className="nav-link" onClick={() => setIsMenuOpen(false)}>The Solution</a>
            <a href="#story" className="nav-link" onClick={() => setIsMenuOpen(false)}>My Story</a>
            <a href="#early-access" className="nav-link cta-link" onClick={() => setIsMenuOpen(false)}>Get Early Access</a>
          </nav>

          <button 
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
          >
            <SafeIcon icon={theme === 'light' ? FiMoon : FiSun} />
          </button>

          <button 
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} />
          </button>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;